import React from 'react';
import { Box, Paper, Stack, Typography, useTheme, styled } from '@mui/material';
import { Link } from 'react-router-dom';
import { StyledMiddleContent, StyledFooter } from './InitPageContainer.styles';
import { createPrefixedPropsFilteredComponent } from 'helpers/styledHelpers';
import LanguageSelector from '../language-selector/LanguageSelector';

const MobileStyledLogo = styled('img')({
  display: 'block',
  height: '35px',
  width: 'auto',
});

const StyledTopRow = styled(Box)({
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: '3.4rem',
});

const StyledBackgroundBox = styled(Box)({
  backgroundImage: 'url("/to_vrts.webp")',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  height: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

const StyledCardPaper = createPrefixedPropsFilteredComponent<{ $cardHeight?: string }>(Paper)(({ $cardHeight }) => ({
  width: '15%',
  minWidth: '300px',
  minHeight: $cardHeight ?? '40vh',
  display: 'flex',
  flexDirection: 'column',
  padding: 0,
  alignItems: 'center'
}));

const StyledMainStack = createPrefixedPropsFilteredComponent<{ $cardHeight?: string }>(Stack)(({ $cardHeight }) => ({
  minHeight: $cardHeight ?? '40vh',
  width: '80%'
}));

type InitPageContainerProps = {
  children: React.ReactNode;
  title: string;
  footerText?: string;
  footerUrl?: string;
  cardHeight?: string;
};

export const InitPageContainer = ({
  children,
  title,
  footerText,
  footerUrl,
  cardHeight,
}: InitPageContainerProps) => {

  const theme = useTheme();

  return (
    <StyledBackgroundBox>     
      <StyledCardPaper $cardHeight={cardHeight}>                 
        <StyledMainStack $cardHeight={cardHeight} data-testid="init-page-login-container">
          <StyledTopRow>
            <MobileStyledLogo src={'ISSVR_Logo.png'} alt="logo" />
            <LanguageSelector />
          </StyledTopRow>
          <Typography marginTop={theme.spacing(5)} marginBottom={theme.spacing(-5)} gutterBottom textAlign={'left'} width='100%' variant='h6'>
            {title}
          </Typography>
          
          {/* Middle Content - Centered */}
          <StyledMiddleContent>
            {children}
          </StyledMiddleContent>  

          {/* Footer */}
          {footerText && footerUrl && <StyledFooter>
            <Link to={footerUrl}>
              <Typography textAlign={'center'}>{footerText}</Typography>
            </Link>
          </StyledFooter>}
        </StyledMainStack>
      </StyledCardPaper>
    </StyledBackgroundBox>
  );
};
